var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvitePendingUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 325.535,
    height: 221.467,
    viewBox: "0 0 325.535 221.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2109",
    "data-name": "Group 2109",
    transform: "translate(-834.308 -218.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2078",
    "data-name": "Group 2078",
    transform: "translate(3215.446 -5870.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2077",
    "data-name": "Group 2077",
    transform: "translate(-2355.138 6036.205)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2023",
    "data-name": "Group 2023",
    transform: "translate(-74 58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2022",
    "data-name": "Group 2022",
    transform: "translate(48 -8.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2019",
    "data-name": "Group 2019",
    transform: "translate(0 24.949)",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9011",
    "data-name": "Path 9011",
    d: "M349.677,301.166c4.524-7.2,5.658-16.122,4.716-24.569a81.048,81.048,0,0,0-7.1-24.834c-3.4-7.235-8.333-13.688-9.737-21.748-1.856-10.647,3-20.882,4.132-31.326,2.246-20.792-11.805-39.113-29.236-49.005-14.158-8.036-30.757-11.05-47.034-10.835-14.65.193-29.275,2.792-43.471,6.286-13.681,3.368-27.057,7.806-41.4,6.406-11.926-1.164-22.668-6.118-33.775-9.812-26.517-8.819-58.639-10.063-82.887,3.363A66.882,66.882,0,0,0,32.6,182.742c-3.539,11.019-4.589,23.688-2,34.84,2.914,12.53,8.3,23.568,6.876,36.767-1.167,10.831-5.146,21.39-4.794,32.377a48.946,48.946,0,0,0,9.339,26.524,11.932,11.932,0,0,0,1.159,1.411H334.215C340.307,311.378,345.994,307.023,349.677,301.166Z",
    transform: "translate(-29.165 -135.049)",
    fill: "#53d0f7"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9087",
    "data-name": "Path 9087",
    d: "M337.684,386.946H51.832a1.143,1.143,0,0,1-1.143-1.143h0a1.142,1.142,0,0,1,1.143-1.142H337.684a1.142,1.142,0,0,1,1.143,1.142h0A1.143,1.143,0,0,1,337.684,386.946Z",
    transform: "translate(-2414.166 5905.692)",
    fill: "#233863"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "translate(892.364 218.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2050",
    "data-name": "Group 2050",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2033",
    "data-name": "Group 2033",
    transform: "translate(151.332 84.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2026",
    "data-name": "Group 2026",
    transform: "translate(0 26.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2025",
    "data-name": "Group 2025"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9014",
    "data-name": "Path 9014",
    d: "M350.887,267.94H306.558a3.236,3.236,0,0,1-3.233-3.232V237.815a3.9,3.9,0,0,1,3.893-3.893h31.8a.576.576,0,0,1,0,1.153h-31.8a2.744,2.744,0,0,0-2.74,2.741v26.893a2.082,2.082,0,0,0,2.08,2.079h44.329a2.082,2.082,0,0,0,2.079-2.079V238.518a3.447,3.447,0,0,0-3.442-3.443h-6.144a.576.576,0,0,1,0-1.153h6.144a4.6,4.6,0,0,1,4.6,4.6v26.191A3.235,3.235,0,0,1,350.887,267.94Z",
    transform: "translate(-303.325 -233.922)",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9015",
    "data-name": "Path 9015",
    d: "M306.554,278.889a.576.576,0,0,1-.383-1.007l18.109-16.111a.577.577,0,1,1,.767.861l-18.11,16.111A.575.575,0,0,1,306.554,278.889Z",
    transform: "translate(-304.449 -245.659)",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9016",
    "data-name": "Path 9016",
    d: "M373.769,279.722a.574.574,0,0,1-.382-.145L355.3,263.546a.576.576,0,0,1,.764-.862l18.084,16.03a.577.577,0,0,1-.382,1.008Z",
    transform: "translate(-325.264 -246.046)",
    fill: "#ffa000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9017",
    "data-name": "Path 9017",
    d: "M329.115,256.021a2.876,2.876,0,0,1-1.709-.564l-22.93-16.85a.576.576,0,1,1,.682-.928l22.93,16.85a1.728,1.728,0,0,0,2.048,0l22.44-16.361a.576.576,0,0,1,.679.931l-22.44,16.361A2.879,2.879,0,0,1,329.115,256.021Z",
    transform: "translate(-303.713 -235.466)",
    fill: "#ffa000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2027",
    "data-name": "Group 2027",
    transform: "translate(27.982 7.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9018",
    "data-name": "Path 9018",
    d: "M372.374,216.369a1.352,1.352,0,0,0,1.6,0l19.072-13.9a4.011,4.011,0,0,0-3.124-1.493h-34.2a3.31,3.31,0,0,0-2.6,1.262.537.537,0,0,1,.066.031Z",
    transform: "translate(-352.403 -200.975)",
    fill: "#2f7ded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9019",
    "data-name": "Path 9019",
    d: "M375.325,227.73a2.5,2.5,0,0,1-2.963-.006l-2.913-2.14-14.714,13.09c-.011.01-.025.013-.036.022a2.647,2.647,0,0,0,1.029.208h36.229a2.662,2.662,0,0,0,.6-.073l-14.646-12.983Z",
    transform: "translate(-353.073 -211.401)",
    fill: "#2f7ded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9020",
    "data-name": "Path 9020",
    d: "M367.3,216.131l-15.257-11.212a3.309,3.309,0,0,0-.17,1.044v21.53a2.642,2.642,0,0,0,.738,1.829.56.56,0,0,1,.159-.264Z",
    transform: "translate(-351.877 -202.646)",
    fill: "#2f7ded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9021",
    "data-name": "Path 9021",
    d: "M411.324,229.589a.538.538,0,0,1,.076.1,2.637,2.637,0,0,0,.974-2.039V206.823a4,4,0,0,0-.3-1.531l-15.449,11.264Z",
    transform: "translate(-370.833 -202.804)",
    fill: "#2f7ded"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2029",
    "data-name": "Group 2029",
    transform: "translate(36.268 63.516)",
    opacity: 0.69
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2028",
    "data-name": "Group 2028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9022",
    "data-name": "Path 9022",
    d: "M399.573,323.415H369.486a3.235,3.235,0,0,1-3.232-3.232V302.72a3.9,3.9,0,0,1,3.893-3.893h28.061a4.6,4.6,0,0,1,4.6,4.6v16.761A3.235,3.235,0,0,1,399.573,323.415ZM370.147,299.98a2.744,2.744,0,0,0-2.74,2.741v17.463a2.082,2.082,0,0,0,2.079,2.079h30.087a2.082,2.082,0,0,0,2.079-2.079V303.422a3.447,3.447,0,0,0-3.443-3.443Z",
    transform: "translate(-366.254 -298.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3497",
    "data-name": "Rectangle 3497",
    width: 17.284,
    height: 1.153,
    transform: "matrix(0.747, -0.665, 0.665, 0.747, 1.285, 23.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3498",
    "data-name": "Rectangle 3498",
    width: 1.152,
    height: 17.232,
    transform: "matrix(0.663, -0.748, 0.748, 0.663, 21.476, 12.768)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9023",
    "data-name": "Path 9023",
    d: "M384.983,314.754a2.219,2.219,0,0,1-1.317-.433L367.315,302.3l.682-.928,16.351,12.016a1.071,1.071,0,0,0,1.266,0l16.94-12.35.679.931-16.94,12.35A2.217,2.217,0,0,1,384.983,314.754Z",
    transform: "translate(-366.703 -299.766)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2032",
    "data-name": "Group 2032",
    transform: "translate(62.062)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_706",
    "data-name": "Ellipse 706",
    cx: 7.24,
    cy: 7.24,
    rx: 7.24,
    ry: 7.24,
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2031",
    "data-name": "Group 2031",
    transform: "translate(4.039 4.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2030",
    "data-name": "Group 2030"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9024",
    "data-name": "Path 9024",
    d: "M419.614,201.88h-.794v-4.792l-.8.494v-.821l.8-.537h.794Z",
    transform: "translate(-418.016 -196.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9025",
    "data-name": "Path 9025",
    d: "M423.426,201.463a1.627,1.627,0,0,1-.41-1.182v-2.57a1.623,1.623,0,0,1,.412-1.184,1.93,1.93,0,0,1,2.406,0,1.629,1.629,0,0,1,.41,1.187v2.57a1.625,1.625,0,0,1-.413,1.184,1.921,1.921,0,0,1-2.405,0Zm1.824-.55a.9.9,0,0,0,.2-.632v-2.57a.913.913,0,0,0-.2-.632.991.991,0,0,0-1.244,0,.91.91,0,0,0-.2.632v2.57a.9.9,0,0,0,.2.632.986.986,0,0,0,1.24,0Z",
    transform: "translate(-420.134 -196.104)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2044",
    "data-name": "Group 2044",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2036",
    "data-name": "Group 2036",
    transform: "translate(0 35.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2034",
    "data-name": "Group 2034",
    transform: "translate(0 19.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9026",
    "data-name": "Path 9026",
    d: "M100.706,172.73a1.48,1.48,0,0,1-1.067-.456l-4.879-5.065a1.738,1.738,0,0,0-1.244-.53l-47.938-.055a4.832,4.832,0,0,1-4.826-4.827V143.62a4.832,4.832,0,0,1,4.827-4.827H96.7a5.5,5.5,0,0,1,5.5,5.5v26.954a1.48,1.48,0,0,1-.93,1.378A1.5,1.5,0,0,1,100.706,172.73ZM45.578,139.946A3.678,3.678,0,0,0,41.9,143.62V161.8a3.678,3.678,0,0,0,3.674,3.674l47.938.055a2.894,2.894,0,0,1,2.074.882l4.879,5.065a.334.334,0,0,0,.575-.231V144.289a4.348,4.348,0,0,0-4.343-4.343Z",
    transform: "translate(-40.751 -138.793)",
    fill: "#2f7ded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9027",
    "data-name": "Path 9027",
    d: "M114.572,156.594H102.29a.576.576,0,1,1,0-1.153h12.282a.576.576,0,1,1,0,1.153Z",
    transform: "translate(-66.579 -145.846)",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9028",
    "data-name": "Path 9028",
    d: "M75.492,156.594H56.69a.576.576,0,1,1,0-1.153h18.8a.576.576,0,1,1,0,1.153Z",
    transform: "translate(-47.26 -145.846)",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9029",
    "data-name": "Path 9029",
    d: "M100.861,164.188H69.926a.576.576,0,0,1,0-1.153h30.934a.576.576,0,1,1,0,1.153Z",
    transform: "translate(-52.867 -149.063)",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9030",
    "data-name": "Path 9030",
    d: "M108.533,171.781h-20.5a.576.576,0,0,1,0-1.153h20.5a.576.576,0,1,1,0,1.153Z",
    transform: "translate(-60.54 -152.28)",
    fill: "#ffa000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2035",
    "data-name": "Group 2035",
    transform: "translate(29.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9031",
    "data-name": "Path 9031",
    d: "M116.047,127.2H99.392a1.956,1.956,0,0,0-1.409.6l-4.143,4.3a.773.773,0,0,1-1.329-.536V108.677a4.177,4.177,0,0,1,4.177-4.177h20.021a3.4,3.4,0,0,1,3.4,3.4v15.239A4.062,4.062,0,0,1,116.047,127.2Z",
    transform: "translate(-92.511 -104.5)",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9032",
    "data-name": "Path 9032",
    d: "M105.66,124.02a1.426,1.426,0,1,1-1.426-1.426A1.426,1.426,0,0,1,105.66,124.02Z",
    transform: "translate(-96.873 -112.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9033",
    "data-name": "Path 9033",
    d: "M117.256,124.02a1.426,1.426,0,1,1-1.426-1.426A1.425,1.425,0,0,1,117.256,124.02Z",
    transform: "translate(-101.786 -112.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_707",
    "data-name": "Ellipse 707",
    cx: 1.426,
    cy: 1.426,
    rx: 1.426,
    ry: 1.426,
    transform: "translate(19.458 10.428)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2040",
    "data-name": "Group 2040",
    transform: "translate(12.529 83.237)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_708",
    "data-name": "Ellipse 708",
    cx: 18.365,
    cy: 18.365,
    rx: 18.365,
    ry: 18.365,
    transform: "translate(0 32.836) rotate(-63.379)",
    fill: "#2f7ded"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2039",
    "data-name": "Group 2039",
    transform: "translate(15.726 14.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2038",
    "data-name": "Group 2038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2037",
    "data-name": "Group 2037"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9034",
    "data-name": "Path 9034",
    d: "M102.285,243.665a3.989,3.989,0,0,1-3.965-3.529l-.075-.643h8.079l-.075.643A3.989,3.989,0,0,1,102.285,243.665Zm-2.668-3.019a2.84,2.84,0,0,0,5.336,0Z",
    transform: "translate(-93.364 -223.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9035",
    "data-name": "Path 9035",
    d: "M107.133,225.081H92.948v-6.514a6.818,6.818,0,0,1,6.809-6.81h.565a6.818,6.818,0,0,1,6.81,6.81ZM94.1,223.929H105.98v-5.362a5.664,5.664,0,0,0-5.657-5.657h-.565a5.664,5.664,0,0,0-5.657,5.657Z",
    transform: "translate(-91.12 -211.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9036",
    "data-name": "Path 9036",
    d: "M105.216,237.842H92.177a2.4,2.4,0,0,1-2.4-2.4v-.165a2.4,2.4,0,0,1,2.4-2.4h13.039a2.4,2.4,0,0,1,2.4,2.4v.165A2.4,2.4,0,0,1,105.216,237.842ZM92.18,234.029a1.25,1.25,0,0,0-1.252,1.248v.165a1.25,1.25,0,0,0,1.248,1.248h13.039a1.249,1.249,0,0,0,1.248-1.248v-.165a1.249,1.249,0,0,0-1.248-1.248Z",
    transform: "translate(-89.776 -220.704)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2043",
    "data-name": "Group 2043",
    transform: "translate(48.169)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_709",
    "data-name": "Ellipse 709",
    cx: 11.531,
    cy: 11.531,
    r: 11.531,
    transform: "translate(0 16.307) rotate(-45)",
    fill: "#2f7ded"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2042",
    "data-name": "Group 2042",
    transform: "translate(15.667 11.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2041",
    "data-name": "Group 2041"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9037",
    "data-name": "Path 9037",
    d: "M151.513,62.434h1.28v6.785h-1.28Zm0,7.846h1.28v1.28h-1.28Z",
    transform: "translate(-151.513 -62.434)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2049",
    "data-name": "Group 2049",
    transform: "translate(139.089 20.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9038",
    "data-name": "Path 9038",
    d: "M373.862,114.994H313.4a5.817,5.817,0,0,0-5.818,5.818v31.876a1.076,1.076,0,0,0,1.851.746l5.77-5.99a2.723,2.723,0,0,1,1.962-.835l56.691-.066a5.026,5.026,0,0,0,5.026-5.026v-21.5A5.026,5.026,0,0,0,373.862,114.994Z",
    transform: "translate(-292.888 -93.242)",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9039",
    "data-name": "Path 9039",
    d: "M348.106,134.834H333.581a.576.576,0,1,1,0-1.153h14.525a.576.576,0,0,1,0,1.153Z",
    transform: "translate(-303.657 -101.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9040",
    "data-name": "Path 9040",
    d: "M396.365,134.834H374.129a.576.576,0,1,1,0-1.153h22.236a.576.576,0,0,1,0,1.153Z",
    transform: "translate(-320.835 -101.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9041",
    "data-name": "Path 9041",
    d: "M370.165,143.815H333.581a.576.576,0,1,1,0-1.153h36.584a.576.576,0,1,1,0,1.153Z",
    transform: "translate(-303.657 -104.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9042",
    "data-name": "Path 9042",
    d: "M357.822,152.795h-24.24a.576.576,0,1,1,0-1.153h24.24a.576.576,0,1,1,0,1.153Z",
    transform: "translate(-303.657 -108.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2045",
    "data-name": "Group 2045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9043",
    "data-name": "Path 9043",
    d: "M286.191,100.211h16.845a1.979,1.979,0,0,1,1.425.606l4.191,4.35a.781.781,0,0,0,1.344-.542V81.477a4.225,4.225,0,0,0-4.225-4.225h-20.25a3.438,3.438,0,0,0-3.438,3.438V96.1A4.108,4.108,0,0,0,286.191,100.211Z",
    transform: "translate(-282.083 -77.252)",
    fill: "#2f7ded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9044",
    "data-name": "Path 9044",
    d: "M315.1,96.995a1.442,1.442,0,1,0,1.443-1.443A1.442,1.442,0,0,0,315.1,96.995Z",
    transform: "translate(-296.069 -85.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9045",
    "data-name": "Path 9045",
    d: "M303.367,96.995a1.442,1.442,0,1,0,1.442-1.443A1.442,1.442,0,0,0,303.367,96.995Z",
    transform: "translate(-291.1 -85.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9046",
    "data-name": "Path 9046",
    d: "M291.363,96.995a1.442,1.442,0,1,0,1.442-1.443A1.442,1.442,0,0,0,291.363,96.995Z",
    transform: "translate(-286.015 -85.005)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2048",
    "data-name": "Group 2048",
    transform: "translate(70.892 13.213)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_710",
    "data-name": "Ellipse 710",
    cx: 8.953,
    cy: 8.953,
    r: 8.953,
    transform: "translate(0 12.661) rotate(-45)",
    fill: "#2f7ded"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2047",
    "data-name": "Group 2047",
    transform: "translate(11.204 8.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2046",
    "data-name": "Group 2046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9047",
    "data-name": "Path 9047",
    d: "M427.009,122.948h-1.232V115.51l-1.25.767V115l1.25-.833h1.232Z",
    transform: "translate(-424.527 -114.169)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2051",
    "data-name": "Group 2051",
    transform: "translate(8.278 142.254)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9048",
    "data-name": "Path 9048",
    d: "M280.949,346.754H265.863a.576.576,0,1,1,0-1.153h15.086a.576.576,0,1,1,0,1.153Z",
    transform: "translate(-144.156 -312.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9049",
    "data-name": "Path 9049",
    d: "M331.071,346.754H307.976a.576.576,0,1,1,0-1.153h23.095a.576.576,0,0,1,0,1.153Z",
    transform: "translate(-161.998 -312.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9050",
    "data-name": "Path 9050",
    d: "M303.86,356.08h-38a.576.576,0,1,1,0-1.153h38a.576.576,0,1,1,0,1.153Z",
    transform: "translate(-144.156 -316.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9051",
    "data-name": "Path 9051",
    d: "M291.039,365.407H265.863a.576.576,0,1,1,0-1.153h25.176a.576.576,0,1,1,0,1.153Z",
    transform: "translate(-144.156 -320.814)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9052",
    "data-name": "Path 9052",
    d: "M94.677,332H55.69a.576.576,0,1,1,0-1.153H94.677a.576.576,0,1,1,0,1.153Z",
    transform: "translate(-55.114 -306.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9053",
    "data-name": "Path 9053",
    d: "M94.677,311.093H55.69a.576.576,0,1,1,0-1.153H94.677a.576.576,0,1,1,0,1.153Z",
    transform: "translate(-55.114 -297.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9054",
    "data-name": "Path 9054",
    d: "M107.885,321.545H86.866a.576.576,0,1,1,0-1.153h21.019a.576.576,0,1,1,0,1.153Z",
    transform: "translate(-68.322 -302.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9055",
    "data-name": "Path 9055",
    d: "M107.885,300.009H86.866a.576.576,0,0,1,0-1.153h21.019a.576.576,0,0,1,0,1.153Z",
    transform: "translate(-68.322 -293.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9056",
    "data-name": "Path 9056",
    d: "M112.916,290.034H98.74a.576.576,0,0,1,0-1.153h14.176a.576.576,0,1,1,0,1.153Z",
    transform: "translate(-73.353 -288.881)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2076",
    "data-name": "Group 2076",
    transform: "translate(36.262 14.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9057",
    "data-name": "Path 9057",
    d: "M223.812,108.664c-.017-.007-.061-.008-.05-.022,7.061-9.416-1.777-21.916-9.476-22.688a23.953,23.953,0,0,0-10.419-7.5,23.537,23.537,0,0,0-6.907-1.425A10.616,10.616,0,1,0,178.455,84.2a23.643,23.643,0,0,0-4.314,6.01c-.269.535-.508,1.077-.733,1.621a16.2,16.2,0,0,0-9.345,29.791c-2.931,1.546-4.785,3.674-4.978,6.138-.225,2.868,1.846,5.636,5.358,7.777a10.719,10.719,0,0,0-1.133,4.786c0,6.6,6.065,11.95,13.546,11.95a13.929,13.929,0,0,0,11.79-6.068,36.528,36.528,0,0,0,5.331,2.859c9.968,4.338,19.879,3.649,22.137-1.538a6.461,6.461,0,0,0,.054-4.652,12.721,12.721,0,0,0,1.763-.42C238.071,136.018,240.787,116.352,223.812,108.664Z",
    transform: "translate(-126.119 -66.493)",
    fill: "#233863"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2058",
    "data-name": "Group 2058",
    transform: "translate(0 83.689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2055",
    "data-name": "Group 2055",
    transform: "translate(6.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2054",
    "data-name": "Group 2054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2052",
    "data-name": "Group 2052",
    transform: "translate(0 0.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9058",
    "data-name": "Path 9058",
    d: "M209.965,256.161l-1.347-3.8,10.1-5.762.318-.182v-.987c0-18.57-11.933-33.624-26.653-33.624H176.761l.2.372L149.4,212.4c-6.871.056-12.7,4.991-14.963,11.893l-19.412,43.33,2.794.342,15.921,1.948.36,44.045,68.258.017,2.253-35.942,2.566-4.192,1.237-2.021A18.5,18.5,0,0,0,209.965,256.161Z",
    transform: "translate(-115.028 -211.805)",
    fill: "#2f7ded"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9059",
    "data-name": "Path 9059",
    d: "M168.637,302.3l-16.166-1.885a.289.289,0,0,1-.253-.32.294.294,0,0,1,.319-.253l15.654,1.825,4.445-19.182a.288.288,0,0,1,.562.131Z",
    transform: "translate(-130.783 -241.596)",
    fill: "#374081"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2053",
    "data-name": "Group 2053",
    transform: "translate(37.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9060",
    "data-name": "Path 9060",
    d: "M197.417,231.143a17.114,17.114,0,0,1-17.095-17.1v-1.929a.418.418,0,0,1,.835,0v1.929a16.259,16.259,0,1,0,32.519,0v-1.929a.418.418,0,0,1,.836,0v1.929A17.114,17.114,0,0,1,197.417,231.143Z",
    transform: "translate(-180.322 -211.701)",
    fill: "#233863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9061",
    "data-name": "Path 9061",
    d: "M188.141,221.839a.417.417,0,0,1-.346-.184,14.112,14.112,0,0,1-2.432-7.944v-1.593a.418.418,0,0,1,.835,0v1.593a13.282,13.282,0,0,0,2.288,7.476.417.417,0,0,1-.112.58A.413.413,0,0,1,188.141,221.839Z",
    transform: "translate(-182.458 -211.701)",
    fill: "#233863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9062",
    "data-name": "Path 9062",
    d: "M203.369,236.989a14.032,14.032,0,0,1-8.84-3.09.417.417,0,1,1,.52-.652,13.358,13.358,0,0,0,16.633.006.417.417,0,0,1,.52.652A14.036,14.036,0,0,1,203.369,236.989Z",
    transform: "translate(-186.274 -220.79)",
    fill: "#233863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9063",
    "data-name": "Path 9063",
    d: "M230.467,220.92a.418.418,0,0,1-.363-.624,13.36,13.36,0,0,0,1.733-6.585v-1.593a.418.418,0,0,1,.835,0v1.593a14.191,14.191,0,0,1-1.843,7A.417.417,0,0,1,230.467,220.92Z",
    transform: "translate(-201.39 -211.701)",
    fill: "#233863"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2057",
    "data-name": "Group 2057",
    transform: "translate(0 56.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2056",
    "data-name": "Group 2056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9064",
    "data-name": "Path 9064",
    d: "M205.587,366.905,194.82,350.715c-2.455-3.149-3.868-6.965-6.729-7.744l-1.928-.492.012-.031-48.289-12,3.984-17.672-28.86-3.531-8.913,29.4a16.647,16.647,0,0,0-.013,7.442,16.467,16.467,0,0,0,15.894,13.432l50.914-.127c5.288,5.537,21.822,16.873,21.822,16.873a1.871,1.871,0,0,0,3.015-1.979l.135-.026c.053.015.1.021.149.035l.706.685a2.083,2.083,0,0,0,2.937-.044l.051-.052a2.06,2.06,0,0,0,.571-1.314l.015.015a2.082,2.082,0,0,0,2.937.033l.052-.051a2.084,2.084,0,0,0,.033-2.938l-.2-.2c-.027-.075-.056-.148-.085-.218a2.078,2.078,0,0,0,2.471-.313l.052-.051A2.084,2.084,0,0,0,205.587,366.905Z",
    transform: "translate(-103.669 -309.246)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9065",
    "data-name": "Path 9065",
    d: "M271.431,410.315a.286.286,0,0,1-.206-.087l-6.4-6.549a.288.288,0,0,1,.412-.4l6.4,6.55a.288.288,0,0,1-.206.49Z",
    transform: "translate(-171.908 -349.046)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9066",
    "data-name": "Path 9066",
    d: "M265.529,414.771a.285.285,0,0,1-.206-.087l-6.4-6.55a.288.288,0,1,1,.412-.4l6.4,6.549a.288.288,0,0,1-.206.49Z",
    transform: "translate(-169.408 -350.934)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9067",
    "data-name": "Path 9067",
    d: "M258.369,417.239a.289.289,0,0,1-.2-.081l-6.6-6.354a.288.288,0,0,1,.4-.416l6.6,6.354a.288.288,0,0,1-.2.5Z",
    transform: "translate(-166.292 -352.063)",
    fill: "#fb8e77"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9068",
    "data-name": "Path 9068",
    d: "M160.29,344.686a.3.3,0,0,1-.089-.014L145.339,339.9a.288.288,0,0,1,.177-.549l14.862,4.777a.288.288,0,0,1-.088.562Z",
    transform: "translate(-121.239 -321.993)",
    fill: "#fb8e77"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2068",
    "data-name": "Group 2068",
    transform: "translate(47.543 34.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2059",
    "data-name": "Group 2059"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9069",
    "data-name": "Path 9069",
    d: "M213.741,125.731c-2.837.426-5.528,3.049-7.685,5.932a9.525,9.525,0,0,1-1.09,1.222,8.837,8.837,0,0,1-10.34,1.206l-.794-.141a6.506,6.506,0,0,0-7.547,5.264l-.021.121a6.507,6.507,0,0,0,5.264,7.547l1.6.285-.421,2.365a17.221,17.221,0,0,0-.225,4.221l-3.717,20.862a11.107,11.107,0,0,0,21.87,3.9l1.485-8.332a17.182,17.182,0,0,0,16.969-14.166l.285-1.6h0L232.9,134.61C228.93,134.118,214.875,131.949,213.741,125.731Z",
    transform: "translate(-186.161 -125.731)",
    fill: "#ffba94"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9070",
    "data-name": "Path 9070",
    d: "M214.057,184.076l-.319-.057a17.185,17.185,0,0,1-14.151-17.71,3.646,3.646,0,0,0-1.846-3.383l-.421,2.365a17.146,17.146,0,0,0,3.766,14.07l14,15.939,1.641-9.213-.345-.149a17.186,17.186,0,0,0,17.32-14.166l.285-1.6A17.182,17.182,0,0,1,214.057,184.076Z",
    transform: "translate(-190.774 -141.489)",
    fill: "#fb8e77",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9071",
    "data-name": "Path 9071",
    d: "M230.978,190.81a.288.288,0,0,1-.2-.5,3.235,3.235,0,0,1,3.576-.527.288.288,0,1,1-.268.509,2.6,2.6,0,0,0-2.911.436A.29.29,0,0,1,230.978,190.81Z",
    transform: "translate(-205.026 -152.722)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2067",
    "data-name": "Group 2067",
    transform: "translate(3.865 6.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9072",
    "data-name": "Path 9072",
    d: "M237.7,157.977a1.074,1.074,0,1,1-.869-1.245A1.074,1.074,0,0,1,237.7,157.977Z",
    transform: "translate(-210.958 -145.159)",
    fill: "#233863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9073",
    "data-name": "Path 9073",
    d: "M259.747,161.905a1.074,1.074,0,1,1-.869-1.245A1.074,1.074,0,0,1,259.747,161.905Z",
    transform: "translate(-220.299 -146.823)",
    fill: "#233863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9074",
    "data-name": "Path 9074",
    d: "M241.892,165.435a5.964,5.964,0,0,1-1.859-.331.288.288,0,1,1,.18-.548c2.423.8,3.459-.2,3.791-.663a.4.4,0,0,0,.07-.295l-1.237-8.121a.288.288,0,0,1,.569-.086l1.237,8.121a.973.973,0,0,1-.169.716A3.031,3.031,0,0,1,241.892,165.435Z",
    transform: "translate(-212.766 -144.495)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3499",
    "data-name": "Rectangle 3499",
    d: "M0,0H9.765a0,0,0,0,1,0,0V4.578A1.514,1.514,0,0,1,8.251,6.092H6.092A6.092,6.092,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(16.789 17.731) rotate(30.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9075",
    "data-name": "Path 9075",
    d: "M226.6,157.908a6.738,6.738,0,0,1-6.73-6.723h0a6.738,6.738,0,0,1,6.724-6.737h.007a6.73,6.73,0,0,1,.007,13.46Zm-5.578-6.724a5.585,5.585,0,0,0,5.578,5.571h.006A5.578,5.578,0,0,0,226.6,145.6h-.006a5.585,5.585,0,0,0-5.572,5.584Z",
    transform: "translate(-204.306 -139.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9076",
    "data-name": "Path 9076",
    d: "M253.149,163.077a6.739,6.739,0,0,1-6.73-6.724h0a6.737,6.737,0,0,1,6.723-6.737h.007a6.73,6.73,0,0,1,.006,13.46Zm-5.578-6.725a5.585,5.585,0,0,0,5.578,5.572h.005a5.578,5.578,0,0,0-.005-11.155h-.006a5.584,5.584,0,0,0-5.571,5.583Z",
    transform: "translate(-215.555 -142.152)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9077",
    "data-name": "Path 9077",
    d: "M244.929,158.976l-.056,0-2.4-.233a.576.576,0,0,1,.112-1.147l2.4.233a.577.577,0,0,1-.055,1.15Z",
    transform: "translate(-213.664 -145.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2066",
    "data-name": "Group 2066",
    transform: "translate(21.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2065",
    "data-name": "Group 2065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2064",
    "data-name": "Group 2064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2061",
    "data-name": "Group 2061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2060",
    "data-name": "Group 2060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9078",
    "data-name": "Path 9078",
    d: "M229.738,138.912a3.076,3.076,0,0,0,1.279.024c.452-.051.908-.092,1.306-.113s.856-.031,1.311-.028a3.057,3.057,0,0,0,1.267-.162c.334-.163.451-.584.018-1.071a3.528,3.528,0,0,0-2.746-.892,3.426,3.426,0,0,0-2.6,1.18C229.212,138.381,229.385,138.786,229.738,138.912Z",
    transform: "translate(-229.373 -136.664)",
    fill: "#233863"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2063",
    "data-name": "Group 2063",
    transform: "translate(15.35 2.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2062",
    "data-name": "Group 2062"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9079",
    "data-name": "Path 9079",
    d: "M260.873,143.963a3.081,3.081,0,0,1-1.2-.437c-.4-.211-.814-.412-1.177-.575s-.788-.337-1.214-.5a3.062,3.062,0,0,1-1.124-.606c-.253-.271-.21-.707.367-1.006a3.529,3.529,0,0,1,2.884.154,3.425,3.425,0,0,1,2,2.036C261.556,143.657,261.248,143.973,260.873,143.963Z",
    transform: "translate(-256.007 -140.606)",
    fill: "#233863"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9080",
    "data-name": "Path 9080",
    d: "M193.155,150.832a.288.288,0,0,1-.071-.567l2.054-.528-.933-3.442a.288.288,0,1,1,.556-.151l1.086,4.006-2.62.673A.276.276,0,0,1,193.155,150.832Z",
    transform: "translate(-192.867 -140.59)",
    fill: "#fb8e77"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2075",
    "data-name": "Group 2075",
    transform: "translate(94.151 71.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2070",
    "data-name": "Group 2070",
    transform: "translate(12.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2069",
    "data-name": "Group 2069"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3500",
    "data-name": "Rectangle 3500",
    d: "M4.883,0H16.627A4.884,4.884,0,0,1,21.51,4.884V31.267a4.884,4.884,0,0,1-4.884,4.884H4.883A4.883,4.883,0,0,1,0,31.268V4.883A4.883,4.883,0,0,1,4.883,0Z",
    fill: "#233863"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2074",
    "data-name": "Group 2074",
    transform: "translate(0 3.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2073",
    "data-name": "Group 2073",
    transform: "translate(4.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9081",
    "data-name": "Path 9081",
    d: "M314.8,256.4l-1.767-32.038.419-3.887a20.785,20.785,0,0,0-4.42-15.158c-.324-.407-.643-.813-.961-1.2v-5.228a2.066,2.066,0,0,0-2.066-2.066,1.993,1.993,0,0,0-1.993,1.992V200.8a6.839,6.839,0,0,1-6.829,6.838l-5.965.007-8.926-.762a2.112,2.112,0,0,0-.948,4.074c-.078.024-.158.049-.238.077l-.248-.021a2.125,2.125,0,0,0-2.291,1.931h0a2.125,2.125,0,0,0,1.93,2.291h.005a2.1,2.1,0,0,0-.677,1.313,2.124,2.124,0,0,0,1.87,2.341l.937.1c.044.031.084.062.129.093,0,0,.024.046.066.122a1.876,1.876,0,0,0,.391,3.593s6.563,2.162,9.4,2.961l-2.4,12.428-.512,2.65-3.244-.591-10.1,5.762,1.347,3.8a18.5,18.5,0,0,1-1.549,15.659l-1.237,2.021,4.936,2.028c6.232,2.56,15.248,5.222,21.926,3.637a19.9,19.9,0,0,0,5.152-1.871C311.742,268.776,315.086,263.045,314.8,256.4Z",
    transform: "translate(-274.92 -196.823)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2071",
    "data-name": "Group 2071",
    transform: "translate(6.007 13.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9082",
    "data-name": "Path 9082",
    d: "M294.779,222.02h-.025l-9.148-.781a.288.288,0,0,1-.262-.312.293.293,0,0,1,.312-.262l9.148.781a.288.288,0,0,1-.024.575Z",
    transform: "translate(-285.343 -220.663)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9083",
    "data-name": "Path 9083",
    d: "M295.092,229.425h-.025l-9.148-.782a.288.288,0,0,1,.05-.574l9.148.782a.288.288,0,0,1-.024.575Z",
    transform: "translate(-285.475 -223.8)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9084",
    "data-name": "Path 9084",
    d: "M297.737,236.61l-.033,0-9.12-1.057a.289.289,0,0,1-.254-.32.292.292,0,0,1,.32-.253l9.12,1.058a.288.288,0,0,1-.033.574Z",
    transform: "translate(-286.608 -226.727)",
    fill: "#fb8e77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2072",
    "data-name": "Group 2072",
    transform: "translate(10.761 39.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9085",
    "data-name": "Path 9085",
    d: "M293.88,285.159a.264.264,0,0,1-.066-.008.288.288,0,0,1-.214-.346l4.574-19.394a.285.285,0,0,1,.347-.214.289.289,0,0,1,.214.347l-4.574,19.394A.288.288,0,0,1,293.88,285.159Z",
    transform: "translate(-293.592 -265.188)",
    fill: "#fb8e77"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9086",
    "data-name": "Path 9086",
    d: "M272.879,272.675l-5.826-13.482a.288.288,0,1,1,.529-.228l5.57,12.891,10.144-5.784a.288.288,0,0,1,.286.5Z",
    transform: "translate(-267.029 -223.076)",
    fill: "#374081"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitePendingUser);
export default __webpack_public_path__ + "static/media/invite-pending-user.6bdbd0fe873c721ada9775b8d981ff5d.svg";
export { ForwardRef as ReactComponent };